import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';

import { UtilsService } from '../../../../core/services/helpers/utils.service';
import { ApiTableService } from '../../../../shared/modules/table/services/api-table/api-table.service';
import { EnumFeatureFlags } from '../../../../user/models/user';
import { DatacolumnTypeEnum } from '../../../models';
import type { TableAttributes } from '../../../models';
import * as tableActions from './table.actions';

@Injectable()
export class TableAttributesEffects {
  private apiTable = inject(ApiTableService);
  private utils = inject(UtilsService);
  private readonly actions$ = inject<Actions>(Actions);

  getTableAttributes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(tableActions.getTableAttributes),
      switchMap(({ originServer }) => this.apiTable.getTableAttributes(originServer)),
      map(attrs => {
        const searchItemAttrs = attrs[DatacolumnTypeEnum.LARISEARCH_ITEM];
        if (!searchItemAttrs) {
          return tableActions.getTableAttributesSuccess({ tableAttributes: attrs });
        }
        const { headings: _h, rendered_headings: _rh, ...rest } = searchItemAttrs.dataattributes ?? {};
        const allowedAttrs: TableAttributes = {
          ...attrs,
          [DatacolumnTypeEnum.LARISEARCH_ITEM]: {
            ...searchItemAttrs,
            ...(this.utils.hasFeature(EnumFeatureFlags.LARI_ITEM_HEADINGS) ? {} : { dataattributes: rest }),
          },
        };
        return tableActions.getTableAttributesSuccess({ tableAttributes: allowedAttrs });
      }),
    ),
  );
}
